import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c3b8164"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jiahao"
}, null, -1));
import api from "@/api/system/auth";
import Dialog from "./components/dialog.vue";
import { computed, onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { useDel } from "@/hook/useDel";
export default {
  __name: 'index',
  setup(__props) {
    const {
      t
    } = useI18n();
    const dialogRef = ref(null);
    const list = ref([]);
    const loading = ref(false);
    const menuType = computed(() => type => {
      switch (type) {
        case 0:
          return {
            text: t("auth.table.catalogue"),
            type: "danger"
          };
        case 1:
          return {
            text: t("auth.table.menu"),
            type: "primary"
          };
        case 2:
          return {
            text: t("auth.table.btn"),
            type: "warning"
          };
        default:
          return "";
      }
    });
    const loadList = async () => {
      loading.value = true;
      try {
        const {
          data
        } = await api.menuList();
        if (data.code !== 0) return;
        list.value = data.data.list;
      } finally {
        loading.value = false;
      }
    };
    const handleClick = (state, row) => {
      const status = state === "add" ? true : false;
      status ? dialogRef.value.open() : dialogRef.value.open(row);
    };
    const handleDel = async row => {
      useDel(async () => {
        await api.menuDel({
          id: row.id
        });
        ElMessage.success(t("action.success"));
        loadList();
      });
    };
    onMounted(() => {
      loadList();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_NoData = _resolveComponent("NoData");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_hoisted_1, _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.add")), 1)]),
          _: 1
        })), [[_directive_permission, '/menu/add']]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          style: {
            "width": "100%",
            "margin-bottom": "20px"
          },
          "row-key": "id"
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            width: "250",
            prop: "name",
            label: _ctx.$t('auth.table.menuName')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "path",
            label: _ctx.$t('auth.table.path')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "component",
            label: _ctx.$t('auth.table.componentPath')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "interfacePath",
            label: _ctx.$t('auth.table.interfacePath')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "order",
            label: _ctx.$t('common.sort')
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('auth.table.type')
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_tag, {
              type: menuType.value(row.menuType).type
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(menuType.value(row.menuType).text), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('auth.table.hidden')
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_tag, {
              type: !row.hidden ? 'primary' : 'danger'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(!row.hidden ? _ctx.$t("auth.table.show") : _ctx.$t("auth.table.hide")), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('auth.table.isLogRecord')
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_tag, {
              type: row.addLog ? 'primary' : 'danger'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(row.addLog ? _ctx.$t("common.yes") : _ctx.$t("common.no")), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('common.action'),
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('edit', row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/menu/edit']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.del")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/menu/del']])]),
            _: 1
          }, 8, ["label"])]),
          _: 2
        }, [!loading.value ? {
          name: "empty",
          fn: _withCtx(() => [_createVNode(_component_NoData)]),
          key: "0"
        } : undefined]), 1032, ["data"])), [[_directive_loading, loading.value]]), _createVNode(Dialog, {
          ref_key: "dialogRef",
          ref: dialogRef,
          list: list.value,
          onLoadList: loadList
        }, null, 8, ["list"])]),
        _: 1
      });
    };
  }
};